(function () {
  var REDUCED_MOTION = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)')
    : { matches: false };

  var CustomFV = function (root) {
    this.root = root;
    this.slides = Array.prototype.slice.call(
      root.querySelectorAll('.image-slide-fv__slide')
    );
    this.dots = Array.prototype.slice.call(
      root.querySelectorAll('.image-slide-fv__dot')
    );
    this.autoplay = root.getAttribute('data-autoplay') === 'true';
    this.interval = parseInt(root.getAttribute('data-interval'), 10) || 5000;
    this.current = 0;
    this.timer = null;

    if (!this.slides.length) return;

    this.bindDots();
    this.bindSwipe();
    this.reveal();
    this.maybeStart();

    // タブ非表示時は停止して無駄な描画を避ける
    document.addEventListener('visibilitychange', this.onVisibility.bind(this));
    if (REDUCED_MOTION.addEventListener) {
      REDUCED_MOTION.addEventListener('change', this.maybeStart.bind(this));
    }
  };

  CustomFV.prototype.reveal = function () {
    var self = this;
    // 次フレームで is-loaded を付与し、1枚目の opacity 0 -> 1 を発火
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        self.root.classList.add('is-loaded');
      });
    });
  };

  CustomFV.prototype.bindDots = function () {
    var self = this;
    this.dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        self.goTo(i);
        self.restart();
      });
    });
  };

  CustomFV.prototype.goTo = function (index) {
    if (index === this.current || !this.slides[index]) return;
    this.slides[this.current].classList.remove('is-active');
    if (this.dots[this.current]) this.dots[this.current].classList.remove('is-active');

    this.current = index;

    this.slides[index].classList.add('is-active');
    if (this.dots[index]) this.dots[index].classList.add('is-active');
  };

  CustomFV.prototype.next = function () {
    var index = (this.current + 1) % this.slides.length;
    this.goTo(index);
  };

  CustomFV.prototype.prev = function () {
    var index = (this.current - 1 + this.slides.length) % this.slides.length;
    this.goTo(index);
  };

  CustomFV.prototype.bindSwipe = function () {
    if (this.slides.length < 2) return;
    var self = this;
    var startX = 0;
    var startY = 0;
    var tracking = false;

    // スマホ: 左右スワイプ。縦スクロール優勢時は反応しない (passiveでネイティブスクロールを妨げない)
    this.root.addEventListener(
      'touchstart',
      function (event) {
        if (event.touches.length !== 1) return;
        tracking = true;
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
      },
      { passive: true }
    );

    this.root.addEventListener(
      'touchend',
      function (event) {
        if (!tracking) return;
        tracking = false;
        var touch = event.changedTouches[0];
        var dx = touch.clientX - startX;
        var dy = touch.clientY - startY;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
        if (dx < 0) {
          self.next();
        } else {
          self.prev();
        }
        self.restart();
      },
      { passive: true }
    );

    this.root.addEventListener(
      'touchcancel',
      function () {
        tracking = false;
      },
      { passive: true }
    );

    // PC: トラックパッドの横スクロール (2本指スワイプ)。連続発火は一定時間ロック
    var wheelLocked = false;
    this.root.addEventListener(
      'wheel',
      function (event) {
        if (Math.abs(event.deltaX) <= Math.abs(event.deltaY) || Math.abs(event.deltaX) < 12) return;
        // ブラウザの「戻る/進む」スワイプジェスチャを抑止
        event.preventDefault();
        if (wheelLocked) return;
        wheelLocked = true;
        window.setTimeout(function () {
          wheelLocked = false;
        }, 700);
        if (event.deltaX > 0) {
          self.next();
        } else {
          self.prev();
        }
        self.restart();
      },
      { passive: false }
    );
  };

  CustomFV.prototype.canAutoplay = function () {
    return (
      this.autoplay &&
      this.slides.length > 1 &&
      !REDUCED_MOTION.matches &&
      !document.hidden
    );
  };

  CustomFV.prototype.maybeStart = function () {
    this.stop();
    if (this.canAutoplay()) {
      this.timer = window.setInterval(this.next.bind(this), this.interval);
    }
  };

  CustomFV.prototype.restart = function () {
    this.maybeStart();
  };

  CustomFV.prototype.stop = function () {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  };

  CustomFV.prototype.onVisibility = function () {
    if (document.hidden) {
      this.stop();
    } else {
      this.maybeStart();
    }
  };

  function init(scope) {
    var roots = (scope || document).querySelectorAll('.image-slide-fv');
    Array.prototype.forEach.call(roots, function (root) {
      if (root.dataset.isfvInit === 'true') return;
      root.dataset.isfvInit = 'true';
      new CustomFV(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  // Shopify テーマエディタでのセクション再読込に対応
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
